/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React, { ForwardedRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface Props {
  children: JSX.Element;
  fullSize?: boolean;
  unlockBackgroundPageScroll?: boolean;
  modalMode?: boolean;
  className?: string;
}

function FloatingPagePortal(
  { children, className = '', unlockBackgroundPageScroll, fullSize, modalMode }: Props,
  ref?: ForwardedRef<HTMLDivElement>
): JSX.Element | null {
  const portalElement = document.getElementById('FloatingPagePortal');

  useEffect(() => {
    if (!unlockBackgroundPageScroll) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      if (!unlockBackgroundPageScroll) {
        document.body.style.overflow = 'auto';
      }
    };
  }, [unlockBackgroundPageScroll]);

  if (!portalElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <>
      {modalMode ? <div className="floating-page-overlay" id="FloatingPage_overlay" /> : null}
      <div
        id="FloatingPage_wrapper"
        className={`floating-page ${modalMode ? 'modal-mode' : ''} ${fullSize ? 'full-size' : ''} ${className}`}
        ref={ref}
      >
        <div id="FloatingPage_container" className="floating-page-container ">
          {children}
        </div>
      </div>
    </>,
    portalElement
  );
}

export default React.forwardRef(FloatingPagePortal);
